/**
 * Canonical question_type labels for CSV and backend (e.g. mcq, mri, fill_blanks).
 * Maps API / LLM variants like "multiple_choice" → "mcq".
 */
export function normalizeQuestionType(rawType) {
  if (rawType == null || rawType === "") return "mcq";

  const cleaned = String(rawType)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  switch (cleaned) {
    case "mcq":
    case "multiple_choice":
    case "multiplechoice":
    case "multiple_choice_question":
    case "multi_choice":
    case "single_choice":
    case "single_select":
      return "mcq";
    case "mri":
    case "multiple_response":
    case "multiple_response_question":
    case "multipleresponse":
      return "mri";
    case "fib":
    case "fill_in_the_blank":
    case "fill_in_the_blanks":
    case "fill_blanks":
    case "fill_blank":
    case "fillintheblank":
    case "fillintheblanks":
      return "fill_blanks";
    case "descriptive":
    case "subjective":
    case "introduction":
    case "hr":
      return "descriptive";
    case "coding":
    case "programming":
      return "coding";
    default:
      // e.g. "multiple_choice_item" from some APIs — treat as MCQ if not MRI
      if (
        cleaned.includes("multiple") &&
        cleaned.includes("choice") &&
        !cleaned.includes("response")
      ) {
        return "mcq";
      }
      return cleaned || "mcq";
  }
}
